export default __webpack_public_path__ + "static/media/locusofcontrol1Img3.9d75a3e5.png";